import React, { useState } from "react";
import {
  Grid,
  Modal,
  Box,
  Snackbar,
  Alert,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { useThemeContext } from "../../context/ThemeContext";
import axios from "../../axios";
import DropProfileImage from "../../Components/components/drop-file-input/DropProfileImage";
import "../../styles/styles.css";

const url = process.env.REACT_APP_BE_URL;


const formStyles = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center"

};
const TitleStyles = {
  fontWeight: "800",
  display: "flex",
  fontSize: "1.25rem",
  marginBottom: "1rem",
};

const style = {
  position: "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, sm: 450 },
  boxShadow: 20,
  p: 4,
  borderRadius: "8px",
  padding: "30px",
  border: "0px",
};

function ImageChangemodel({ open, onClose, userData, updateData }) {
  const { isDarkMode } = useThemeContext();

  // eslint-disable-next-line
  const [documentUpload, setDocumentUpload] = useState(true);
  const [imageFIle, setImageFIle] = useState();
  const [btnDisabled, setbtnDisabled] = useState(false)

  const [alert, setAlert] = useState({
    showAlert: false,
    severity: "success",
    message: "",
  });

  function handleClose() {
    setAlert({
      ...alert,
      showAlert: false,
      severity: "",
      message: "",
    });
  }

  const onFileChange = async ([files]) => {
    // files is an array of base64 data URLs from DropProfileImage; store only the first
    setImageFIle(Array.isArray(files) ? (files[0] || null) : files);
    setDocumentUpload(false);
  };

  const onImageDelete = async () => {
    setbtnDisabled(true)

    const config = {
      headers: {
        Authorization: `Bearer ${JSON.parse(localStorage.getItem("userInfo")).token
          }`,
      },
    };

    try {
      let payLoad = {
        profilePic: "",
      };

      const { status } = await axios.put(
        `${url}/user/${userData._id}`,
        payLoad,
        config
      );

      if (status === 200) {
        setAlert({
          showAlert: true,
          severity: "success",
          message: "Profile Picture Deleted!",
        });
        setbtnDisabled(false)
        updateData();

        onClose();

        setTimeout(() => {
          setAlert({
            showAlert: false,
            severity: "success",
            message: "",
          });
        }, 16000);
      }
    } catch (error) {
      setbtnDisabled(false)

      setAlert({
        showAlert: true,
        severity: "error",
        message: `${error.response.data.message ? error.response.data.message : error.response.data ? error.response.data : "Action failed"}`,
      });

      setTimeout(() => {
        setAlert({
          showAlert: false,
          severity: "success",
          message: "",
        });
      }, 16000);
    }
  };

  const onImageSubmit = async () => {
    setbtnDisabled(true)

    const config = {
      headers: {
        Authorization: `Bearer ${JSON.parse(localStorage.getItem("userInfo")).token
          }`,
      },
    };

    try {
      let payLoad = {
        // profilePic: store single base64 data URL string or empty
        profilePic: imageFIle || "",
      };

      const { status } = await axios.put(
        `${url}/user/${userData._id}`,
        payLoad,
        config
      );

      if (status === 200) {
        setAlert({
          showAlert: true,
          severity: "success",
          message: "Profile Picture Updated!",
        });
        setbtnDisabled(false)
        updateData();

        onClose();

        setTimeout(() => {
          setAlert({
            showAlert: false,
            severity: "success",
            message: "",
          });
        }, 16000);
      }
    } catch (error) {
      setAlert({
        showAlert: true,
        severity: "error",
        message: `${error?.data
          ? error.data
          : error.data?.message ? error.data?.message : error.response.data ? error.response.data : "Action Failed!"}`,
      });

      setTimeout(() => {
        setAlert({
          showAlert: false,
          severity: "success",
          message: "",
        });
      }, 16000);
    }
  };

  return (
    <>
      <Snackbar
        sx={{ mt: "8vh" }}
        open={alert.showAlert}
        autoHideDuration={15000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleClose}
          severity={alert.severity}
          sx={{
            fontSize: "16px",
          }}
        >
          {alert.message}
        </Alert>
      </Snackbar>

      <Modal open={open} onClose={onClose}>
        <Box sx={{
          ...style,
          bgcolor: isDarkMode ? '#1e293b' : '#fff',
          color: isDarkMode ? '#f1f5f9' : '#000',
        }}>
          <Grid container justifyContent="center">
            <Grid item sx={{
              ...TitleStyles,
              backgroundColor: isDarkMode ? '#1e293b' : '#fff',
              color: isDarkMode ? '#f1f5f9' : '#000',
            }}>
              Update Profile Picture
            </Grid>
            <Grid container item direction="column" alignItems="center">
              <form style={formStyles}>
                <Grid item
                  sx={{
                    border: isDarkMode ? '1px dashed #475569' : "1px dashed #e5e7eb",
                    borderRadius: "8px",
                    width: { xs: 298, sm: 398 },
                    padding: 2,
                    background: isDarkMode ? '#0f172a' : "#fff",
                  }} >
                  <DropProfileImage
                    onFileChange={(files) => onFileChange(files)}
                  />
                </Grid>
                <Grid item sx={{ width: { xs: 298, sm: 398 }, mt: 2, display: 'flex', gap: 2, justifyContent: 'center' }}>
                  <LoadingButton
                    sx={{
                      borderRadius: "8px",
                      fontSize: "0.875rem",
                      fontWeight: "600",
                      height: "2.25rem",
                      px: 2,
                      minWidth: 140,
                    }}
                    color="primary"
                    variant="contained"
                    type="submit"
                    size="small"
                    onClick={onImageSubmit}
                    loading={btnDisabled}
                  >
                    Submit
                  </LoadingButton>

                  <LoadingButton
                    sx={{
                      borderRadius: "8px",
                      fontSize: "0.875rem",
                      fontWeight: "600",
                      height: "2.25rem",
                      px: 2,
                      minWidth: 140,
                    }}
                    color="error"
                    variant="outlined"
                    size="small"
                    onClick={onImageDelete}
                    loading={btnDisabled}
                  >
                    Delete
                  </LoadingButton>
                </Grid>
              </form>
            </Grid>
          </Grid>
        </Box>
      </Modal>

    </>
  );
}

export default ImageChangemodel;
